export enum PlanFrequencyEnum {
    Monthly = 'Monthly',
    Yearly = 'Yearly',
}
